<template>
  <section class="pb-100" :style="`background-color: var(--${backgroundColor}) !important`">
    <div :class="variants.v3 === variant ? '' : 'page-padding'">
      <div class="container-large">
        <div class="tw-py-16">
          <!-- Industry Insights Header -->
          <div class="industry-insights-header tw-text-center tw-mb-16">
            <div class="max-width-large tw-text-center">
              <h3 class="insights-main-title  tw-mb-4">
                {{ vars.titleText }}
              </h3>
            </div>
          </div>

          <!-- Blog Cards Grid -->
          <div class="insights-grid tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
            <div v-for="(blog, index) in blogs" :key="`insight-${index}`" class="insight-card">
              <nuxt-link
                :to="blog.url_in_use"
                class="card-link tw-block tw-transition-all tw-duration-300 hover:tw-transform tw-h-full"
                :external="true"
              >
                <div class="card-image-wrapper tw-relative tw-overflow-hidden tw-mb-4" style="aspect-ratio: 480/320;">
                  <img
                    alt=""
                    loading="lazy"
                    :src="blog.image "
                    class="cover-image tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300"
                  />
                </div>
                
                <div class="card-content">
                  <div class="card-title tw-mb-3">
                    <h3 class="tw-text-start tw-line-clamp-2 tw-font-bold tw-text-lg tw-text-gray-900">
                      {{ blog.title }}
                    </h3>
                  </div>
                  <p class="tw-text-start tw-line-clamp-3 tw-mb-4 tw-text-gray-600 tw-text-sm">
                    {{ blog.description }}
                  </p>
                  
                  <!-- Green bottom line -->
                  <div class="bottom-line"></div>
                </div>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme2/base/NotFound.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme2ManualBlogsBox',
  components: { NcButton, NotFound, Loader },

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    backgroundColor() {
      return getVariable(this.component, 'background-color');
    },

    variant() {
      return useVariant(this.component);
    },

    blogs() {
      const blogs = this.groupedVariables.blogs;

      return blogs.map((blog) => {
        return {
          ...blog,
          url_in_use: blog.url && blog.url.includes('blogs') ? blog.url : `/blogs/${blog.url}`,
        };
      });
    },

    titleHtml() {
      return this.vars.titleHtml || 'Take a look at our latest blogs';
    },
  },
});
</script>

<style scoped>
/* Industry Insights Header */
.industry-insights-header {
  position: relative;
}

.insights-main-title {
  color: #1f2937;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Card Styles */
.insight-card {
  position: relative;
  transition: all 0.3s ease;
  height: 100%;
}

.insight-card:hover {
  transform: translateY(-5px);
}

.card-link {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-image-wrapper {
  background: #f8fafc;
  border-radius: 8px;
  overflow: hidden;
}

.cover-image {
  transition: transform 0.3s ease;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 16px;
}

.card-title h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.4;
}

.card-content p {
  flex: 1;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
}

/* Green bottom line */
.bottom-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #90C73D;
  border-radius: 1px;
}

/* Line clamp utilities */
.tw-line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tw-line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .insights-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .insights-grid {
    grid-template-columns: 1fr;
  }
  
  .insights-main-title {
    font-size: 2rem;
  }
}

@media (max-width: 640px) {
  .insights-main-title {
    font-size: 1.75rem;
  }
}
</style>